import { render, staticRenderFns } from "./UserM.vue?vue&type=template&id=118ac758&scoped=true&"
import script from "./UserM.vue?vue&type=script&lang=ts&"
export * from "./UserM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118ac758",
  null
  
)

export default component.exports